<template>
  <ul class="list-group list-group-bordered">
    <li class="list-group-item"
        v-for="funder in funders"
        :key="funder.id">
      <div class="list-group-item-figure">
        <a href="#" class="tile tile-circle bg-red"><span class="fa fa-file-archive"></span></a>
      </div>
      <div class="list-group-item-body">
        <h4 class="list-group-item-title">{{ funder.title }}</h4>
        <div class="list-group-item-text">${{ funder.formatted_budget }}</div>
        <div class="list-group-item-text">
          <a :href="`/${funder.agreement_path}`" target="_blank">{{ funder.agreement }}</a>
        </div>
      </div>
    </li>
    <div class="w-100 text-center mt-3" v-if="funders.length === 0">
      <div class="spinner-border spinner-border-sm text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </ul>
</template>
<script>
  export default {
    name: 'FundersList',
    props: {
      protocol: Object,
      funders: Array,
    },
  }
</script>
